<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>Hilfe</ion-title>
    @if(!state.isBigScreen){
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    }@else{
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div style="padding: 10px">
    <ion-accordion-group>
      <ion-accordion value="first">
        <ion-item slot="header" color="light">
          <ion-label>Baustellen</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          Hier können Baustellen angelegt und verwaltet werden. Dieser Menüpunkt
          dient ebenfalls als zentrale Dokumentenablage für alle Baustellen.
          Beim Anlegen einer neuen Baustelle werden Standart-Ordner angelegt.
          Weitere Ordner können manuell angelegt werden. In den Ordnern lassen
          sich Dokumente der Baustelle ablegen und über einen Klick anschauen.
        </div>
      </ion-accordion>
      <ion-accordion value="second">
        <ion-item slot="header" color="light">
          <ion-label>Bautagesberichte</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          Über die Bautagesberichte werden alle Arbeiten und Zeiten einer
          Baustelle erfasst. Erfasste Mitarbeiterstunden im Bautagesbericht
          tauchen nach dem Abschicken ebenfalls im Arbeitszeit-Menü auf. Sobald
          ein Bautagesbericht bestätigt ist werden die Mitarbeiterstunden
          ebenfalls bestätigt. Wenn ein Bautagesbericht in der Tabelle
          ausgewählt wird kann über den Knopf "Anzeigen" eine Druckversion
          erstellt werden. Bautagesberichte können fehlerhaft sein wenn manuell
          angelegte Stunden eines Mitarbeiters nicht mit den Stunden im
          Bautagesbericht übereinstimmen. Fahrtenberichte und
          Arbeitszeitberichte sind kleinere Formen des Bautagesberichts und für
          Fahrten sowie kleine Arbeiten gedacht.
        </div>
      </ion-accordion>
      <ion-accordion value="third">
        <ion-item slot="header" color="light">
          <ion-label>Arbeitszeit</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          Über das Arbeitszeit-Menü können alle erfassten Stunden eingesehen
          werden. Über das Optionsmenü neben der Jahresauswahl kann eine Monats-
          oder Jahresübersicht entweder nach Mitarbeiter oder nach Baustelle
          erstellt werden. Diese Übersicht enthält ausschließlich bestätigte
          Stunden! Arbeitszeiten die manuell angelegt, nicht bestätigt und
          keinem Bautagesbericht zugeordnet sind können über das
          Drei-Punkte-Menü in einen Arbeitszeitbericht umgewandelt werden.
        </div>
      </ion-accordion>
      <ion-accordion value="fourth">
        <ion-item slot="header" color="light">
          <ion-label>Abwesenheit</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          Einfache Abwesenheitsübersicht aller Mitarbeiter. Abwesenheiten werden
          in der Monats- und Jahresübersicht zusätzlich sichtbar. Je nach
          Export-Schnittstelle können Abwesenheiten auch exportiert werden.
        </div>
      </ion-accordion>
      <ion-accordion value="fifth">
        <ion-item slot="header" color="light">
          <ion-label>Maschinenpark</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          Im Maschinenpark können Maschinen sowie DGUV-Prüfungen angelegt
          werden. Bei der Prüfung kann für jedes Bauteil festgelegt werden ob es
          "In Ordnung" ist. Ebenfalls kann für jedes Bauteil eine Notiz
          hinterlegt werden. Standartmäßig sind alle Bauteile als "In Ordnung"
          gekennzeichnet. DGUV-Prüfungen können auf Wunsch über den Knopf
          "Anzeigen" auch ausgedruckt werden.
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>
</ion-content>
